import {Sortable} from '@shopify/draggable'

window.sfDocumentReady(['route-approvals-priorities'], () => {
  const containerSelector = '.sortable-approvals'
  const itemSelector = `${containerSelector} .sortable__item`
  const containers = $(containerSelector).get()

  $(itemSelector).find('.indicator__refresh').on('click', () => window.location.reload())

  const sortable = new Sortable(
    containers,
    {
      draggable: `${itemSelector}:not(.disabled)`,
      mirror: {
        appendTo: containerSelector,
        constrainDimensions: true,
      }
    }
  )

  sortable.on('sortable:stop', event => {
    const element = event.dragEvent.data.originalSource
    const newIndex = event.data.newIndex
    const oldIndex = event.data.oldIndex

    if (newIndex === oldIndex) {
      return
    }

    const id = $(element).data('id')
    const newOrder = getNewOrder()

    let mode
    let anchorId

    if (newIndex === 0) {
      mode = 'before'
      anchorId = newOrder[newIndex + 1]
    } else {
      mode = 'after'
      anchorId = newOrder[newIndex - 1]
    }

    $(element).addClass('disabled')
      .removeClass('sortable__item--processed')
      .addClass('sortable__item--processing')

    setApprovelOrder(id, mode, anchorId)
      .then(() => {
        $(element).removeClass('disabled')
          .removeClass('sortable__item--processing')
          .addClass('sortable__item--processed')
      })
      .catch(err => {
        const message = typeof err.response.data.message !== 'undefined'
          ? err.response.data.message
          : err.message
        $(element).find('.item__indicator--error .fa').attr('title', message)
        $(element).addClass('disabled')
          .addClass('sortable__item--error')
          .removeClass('sortable__item--processing')
      })
  })

  const setApprovelOrder = async (id, mode, anchorId) => {
    return Api.put('approvals/priorities', {
      id,
      [mode]: anchorId
    })
  }

  // const getCurrentOrder = () => $(`${itemSelector}:not(.draggable-source--is-dragging):not(.draggable-mirror)`).toArray().map(el => $(el).data('id'))
  const getNewOrder = () => $(`${itemSelector}:not(.draggable--original):not(.draggable-mirror)`).toArray().map(el => $(el).data('id'))
})
